import type { AbilityDef } from "../../sim";

/** «Сальто»: ← + ○ — прыжок с переворотом и удар пятками сверху (блок только стоя). */
export const FLIP_KICK: AbilityDef = {
  id: "flip-kick",
  name: "Сальто",
  input: { button: "heavyKick", hold: "B" },
  pose: "flip",
  startup: 14,
  active: 10,
  recovery: 10,
  // сальто показывает сам клип (бёдра идут вверх в клипе); подброс в мире поднимал тело ещё на ~114 px — пятки
  // проходили над головой соперника (замер касания 05.11.2026: 97 px). Зона удара — где стопа в кадр удара клипа:
  // ~84 px вперёд, ~104 px вверх (content/abilities/reach.ts).
  actions: [{ frame: 3, type: "leap", params: { up: 0, forward: 6 } }],
  hitbox: { x: 46, y: -132, w: 44, h: 56 },
  hit: { damage: 90, hitstun: 22, blockstun: 14, hitstop: 12, push: 8, height: "overhead" },
  fx: { hit: "heavy/spark", block: "block/spark" },
  sound: { start: "whoosh", hit: "hit-heavy" },
};
